/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/blocks/logos.module.scss';

const propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
            image: PropTypes.string,
            width: PropTypes.string,
        }),
    ),

    className: PropTypes.string,
};

const defaultProps = {
    items: [],
    className: null,
};

const LogosBlock = ({ items, className }) => {
    return items && items.length > 0 ? (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {items.map(({ name, url, image, width }) => (
                <a
                    className={styles.link}
                    key={name}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img className={styles.image} src={image} width={width} alt={name} />
                </a>
            ))}
        </div>
    ) : null;
};

LogosBlock.propTypes = propTypes;
LogosBlock.defaultProps = defaultProps;

export default LogosBlock;
